import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getOrganizationTypeProfileInfo, normalizeWebsiteLink } from 'src/app/common/app.helpers';
import { OrganizationDisplayedInfo } from 'src/app/interfaces/profile.interface';

@Component({
  selector: 'app-role-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleOrganizationComponent {
  @Input({ required: true }) public content: OrganizationDisplayedInfo;

  public get normalizedLink(): string {
    return normalizeWebsiteLink(this.content.website);
  }

  public get getOrganizationType(): string {
    return getOrganizationTypeProfileInfo(this.content.organization_type).value.toString();
  }
}
